import { CreateInvoiceRequestSchema } from '@weft/api-definition';
import { oz } from '@weft/utils';

export const NewInvoiceFormSchema = oz.object(CreateInvoiceRequestSchema.shape).refine(data => data.fixedProducts.length > 0, {
  message: 'Plan must have at least one product',
  path: ['productsValidation'],
});

export type NewInvoiceForm = oz.infer<typeof NewInvoiceFormSchema>;